var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1663",
    "data-name": "Rectangle 1663",
    width: 27,
    height: 27,
    transform: "translate(0.008 0.006)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2231",
    "data-name": "Group 2231",
    transform: "translate(-0.008 -0.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2230",
    "data-name": "Group 2230",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48876",
    "data-name": "Path 48876",
    d: "M26.508,13.253A13.254,13.254,0,1,1,13.254,0,13.253,13.253,0,0,1,26.508,13.253",
    transform: "translate(0 0)",
    fill: "#4dcb5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48877",
    "data-name": "Path 48877",
    d: "M6.722,21.3l1.1-4.123a7.633,7.633,0,1,1,3.039,3.012Zm4.35-2.655.261.156a6.195,6.195,0,1,0-2.119-2.1l.16.263-.617,2.3Z",
    transform: "translate(-0.629 -0.551)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48878",
    "data-name": "Path 48878",
    d: "M17.738,14.99a1.278,1.278,0,0,0-1.09-.246c-.283.116-.464.559-.647.786a.272.272,0,0,1-.351.076A4.936,4.936,0,0,1,13.185,13.5a.3.3,0,0,1,.038-.412,1.671,1.671,0,0,0,.448-.727,1.59,1.59,0,0,0-.2-.86,2.04,2.04,0,0,0-.635-.957.87.87,0,0,0-.945.141,1.918,1.918,0,0,0-.665,1.52,2.161,2.161,0,0,0,.06.482,3.992,3.992,0,0,0,.463,1.066,8.2,8.2,0,0,0,.483.734,7.446,7.446,0,0,0,2.095,1.946,6.343,6.343,0,0,0,1.306.621,2.9,2.9,0,0,0,1.521.24,1.841,1.841,0,0,0,1.38-1.026.89.89,0,0,0,.063-.523c-.079-.361-.567-.576-.858-.75",
    transform: "translate(-1.05 -0.977)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/Whatsapp.a522c8a1b531894104eaeea95d52a214.svg";
export { ForwardRef as ReactComponent };